import React from "react";
import Typography from "@material-ui/core/Typography";
import TablaModificacionesParaAprobar from "../components/TablaModificacionesParaAprobar";
import Grid from "@material-ui/core/Grid";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import useToken from "../useToken";

class Modificaciones extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            value: 'sca',
            showTabla: true,
            user: useToken.getUser(),
        }
    }

    handleChange = (event) => {
        this.setState({value: event.target.value, showTabla: !this.state.showTabla});
        setTimeout(() => {
            // After X seconds set the show value to false
            this.setState({showTabla:!this.state.showTabla})
        }, 30)
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Modificaciones
                </Typography>
                {(this.state.user.app !== 'sodimac' && this.state.user.app !== 'sodimac_auditoria' )&&
                    <Grid  container spacing={2} direction={"row"} justifyContent={"flex-start"} alignItems="center">
                    <Grid item>
                        <RadioGroup style={{ display: 'inline-block'}} aria-label="gender" name="value" value={this.state.value} onChange={this.handleChange}>
                            <FormControlLabel value="sca" control={<Radio/>} label="SCA"/>
                             <FormControlLabel value="cliente" control={<Radio/>} label="Cliente"/>
                        </RadioGroup>
                    </Grid>
                </Grid>}
                {this.state.showTabla &&
                    <TablaModificacionesParaAprobar tipo={this.state.value}/>}
            </div>
        )
    }
}

export default Modificaciones;